import { Link } from 'react-router';

const SessionCard = ({ session }) => {
  // Determine quiz type
  const quizType = session.course_title
    ? 'Course Quiz'
    : session.topic_detail
    ? 'Topic Quiz'
    : 'Quiz';

  return (
    <div className="card bg-base-100 shadow-md hover:shadow-lg transition-shadow">
      <div className="card-body p-6">
        <div className="flex justify-between items-start gap-4">
          {/* Left Section - Quiz Info */}
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <h3 className="card-title text-lg">
                {session?.topic_detail?.title || session?.course_title}
              </h3>
              <span className="badge badge-info">{quizType}</span>
            </div>
            
            {/* Student Info */}
            <div className="flex items-center gap-2 mb-1">
              <div className="avatar placeholder">
                <div className="bg-neutral text-neutral-content rounded-full w-8">
                  <span className="text-xs">
                    {session.user_detail.first_name[0]}
                    {session.user_detail.last_name[0]}
                  </span>
                </div>
              </div>
              <div>
                <div className="font-medium">
                  {session.user_detail.first_name} {session.user_detail.last_name}
                </div>
                <div className="text-sm text-gray-500">{session.user_detail.email}</div>
              </div>
            </div>
          </div>

          {/* Right Section - Stats */}
          <div className="flex flex-col items-end gap-2">
            {/* Score Badge */}
            <div className="stats shadow">
              <div className="stat px-4 py-2">
                <div className="stat-title text-xs">Score</div>
                <div className="stat-value text-lg">
                  {session.correct_answer_count}/{session.total_question_count}
                </div>
              </div>
            </div>

            {/* Status Badge */}
            <div className={`badge ${
              session.completed_at 
                ? 'badge-success text-success-content' 
                : 'badge-warning text-warning-content'
            } badge-lg`}>
              {session.completed_at ? 'Completed' : 'In Progress'}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-between items-center mt-4 pt-4 border-t">
          <div className="text-sm text-gray-500">
            Started: {new Date(session.started_at).toLocaleString()}
          </div>
          <Link 
            to={`/quizzes/${session.id}/results`}
            className="btn btn-primary btn-sm"
          >
            View Results
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SessionCard;